import { useContext } from 'react';
import { numberWithCommas } from '../../../utils/format';
import SimpleTable from '../../SimpleTable';
import { QAStoreContext } from './QAStore';

const STAT_VALUE_WARNING_AMOUNT = 150000;

// for QA screen, displays totals for Item Rows, Packages, Gross (Kg) .etc at top of checklist
const ItemTotals = () => {
  const qaStore = useContext(QAStoreContext);

  const hiddenFields = qaStore.currentConfig[0].hideTotalValues;
  const [itemTotals] = qaStore.itemTotals;
  const [invoiceCurrency] = qaStore.invoiceCurrency;
  const statValueWarning = qaStore.statValueWarning;

  const { packageCount, grossMass, netMass, value, valueGbp, dutyLiabilityGbp, vatLiabilityGbp, itemRows } = itemTotals;

  const tableData = {
    headings: [
      {
        label: 'Item Rows',
        key: 'itemRows',
      },
      {
        label: 'Packages',
        key: 'packages',
      },
      {
        label: 'Gross (Kg)',
        key: 'grossKg',
      },
      {
        label: 'Net (Kg)',
        key: 'netKg',
      },
      {
        label: `Total Value (${invoiceCurrency})`,
        key: 'totalValue',
      },
      {
        label: 'Stat Value (GBP)',
        key: 'statValue',
        warning: statValueWarning,
      },
      {
        label: 'Total Duty (GBP)',
        key: 'totalDuty',
        hide: hiddenFields.totalDuty,
      },
      {
        label: 'Total VAT (GBP)',
        key: 'totalVAT',
        hide: hiddenFields.totalVAT,
      },
    ],
    values: [
      {
        id: 'item-totals-table-values',
        itemRows: numberWithCommas(itemRows),
        packages: numberWithCommas(packageCount),
        grossKg: numberWithCommas(grossMass, true),
        netKg: numberWithCommas(netMass, true),
        totalValue: numberWithCommas(value, true),
        statValue: numberWithCommas(valueGbp, true),
        totalDuty: dutyLiabilityGbp === 'CALCULATION' ? dutyLiabilityGbp : numberWithCommas(dutyLiabilityGbp, true),
        totalVAT: vatLiabilityGbp === 'CALCULATION' ? vatLiabilityGbp : numberWithCommas(vatLiabilityGbp, true),
      },
    ],
  };

  return <SimpleTable data={tableData} dataTestIdPrefix="itemTotals" />;
};

export default ItemTotals;
